export default __webpack_public_path__ + "static/media/eticket.4b82881a.jpeg";